import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import Chart from 'chart.js/auto';
import { DashboardUgService } from 'src/app/services/dashboard/dashboard-ug.service';
import { GlobalService } from 'src/app/services/shared/global.service';
import { Router } from '@angular/router';
import { PendingPaymentsData, PendingPaymentsResponse } from '../models/IPendingPaymentsResponse';

@Component({
  selector: 'app-azaan-admin-dashboard',
  templateUrl: './azaan-admin-dashboard.component.html',
  styleUrls: ['./azaan-admin-dashboard.component.css']
})
export class AzaanAdminDashboardComponent implements OnInit{
  units_in_supplier_stock_count: number = 0;
  units_enroute_count: number = 0;
  units_at_cfs_count: number = 0;
  units_in_transit_to_ug_count: number = 0;
  public total_stock_chart: any;
  public total_stock: any[] | null = null;
  public stock_available_by_make: any[] = [];
  public stock_available_by_model: any[] = [];
  branches: any[] = [];
  selectedBranch: string='';
  public branchId:string|null=null;
  pendingPayments!: PendingPaymentsData;
  public isLoading: boolean = false;
  @ViewChild('AvailableModels') availableModelsModalElement!: ElementRef;
  public make_id:string='';
  public make_name:string='';
  @ViewChild('AvailableUnits') availableUnitsModalElement!: ElementRef;
  public model_id:string='';
  public model_name:string='';
  model_page: number = 1;
  model_count: number = 0;
  modelSearchText: string = '';
  public units_by_model: any[] = [];
  units_page: number = 1;
  units_count: number = 0;
  unitsSearchText: string = '';
  searchText: string = '';
  page: number = 1;
  count: number = 0;
  dueDutyPayments: any[] = [];

  constructor(
    private dashboardUgService: DashboardUgService,
    private globalService: GlobalService,
    private router: Router,
  ){}

  ngOnInit(): void {
    this.isLoading=true;

    this.countUnitsInSupplierStock();
    this.countUnitsEnroute();
    this.countUnitsAtCfs();
    this.countUnitsInUganda();
    this.getTotalStockByLocation();
    this.countPendingPayments();
    this.getAvailableStockByMake();
    this.fetchBranches();
    this.loadDueDutyPayments();
  }

  /**
   * Count units in supplier stock
   */
  countUnitsInSupplierStock(){
    this.isLoading=true;

    this.dashboardUgService.countUnitsInSupplierStock()
    .subscribe((response: any) => {
      if(response.status==='success'){
        this.isLoading=false;
        this.units_in_supplier_stock_count = response.data;
      }else{
        this.isLoading=false;
      }
    });
  }

  /**
   * Count units en route
   */
  countUnitsEnroute(){
    this.isLoading=true;

    this.dashboardUgService.countUnitsEnroute()
    .subscribe((response: any) => {
      if(response.status==='success'){
        this.isLoading=false;
        this.units_enroute_count = response.data;
      }else{
        this.isLoading=false;
      }
    });
  }

  /**
   * Count units at CFS
   */
  countUnitsAtCfs(){
    this.isLoading=true;

    this.dashboardUgService.countUnitsAtCFS()
    .subscribe((response: any) => {
      if(response.status==='success'){
        this.isLoading=false;
        this.units_at_cfs_count = response.data;
      }else{
        this.isLoading=false;
      }
    });
  }

  /**
   * Count units in transit to Uganda
   */
  countUnitsInUganda(){
    this.isLoading=true;

    this.dashboardUgService.countUnitsInTransitToUganda()
    .subscribe((response: any) => {
      if(response.status==='success'){
        this.isLoading=false;
        this.units_in_transit_to_ug_count = response.data;
      }else{
        this.isLoading=false;
      }
    });
  }

  getTotalStockByLocation():void{
    this.isLoading=true;

    this.dashboardUgService.totalStockByLocation()
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.total_stock = response.data;

          if (this.total_stock.length > 0) {
            const chartLabels =this.total_stock.map((item) => item.location_name);
            const chartData = this.total_stock.map((item) => item.total_stock);

            // Call the method to create the chart with dynamic data
            this.totalStockChart(chartLabels, chartData);
          }

          this.isLoading=false;
        }else if(response.status==='no_data'){
            this.isLoading=false;
        }else{
          const errorMessage="A problem was encountered while fetching total stock. Please refresh the page and try again!";
          this.globalService.setGlobalWarningMessage(errorMessage);
          this.isLoading=false;
        }
      },
      error: (error) => {
        this.isLoading=false;
        this.globalService.setGlobalWarningMessage("Total Stock: "+error);
      }
    });
  }

  totalStockChart(labels: string[], data: number[]):void {
    this.total_stock_chart = new Chart('TotalStockChart', {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [
          {
            label: 'Stock Available',
            data: data,
            borderWidth: 1,
            backgroundColor: 'rgba(255, 140, 0, 0.2)',
          },
        ],
      },
      options: {
        onClick: (event, elements) => {
          if (elements.length > 0) {
            const chart = this.total_stock_chart;
            const index = elements[0].index;
            const label = chart.data.labels[index];

            if(label=='EN ROUTE'){
              this.router.navigate(['stock-overview/stock-en-route-ug']);
            }else if(label=='CFS'){
              this.router.navigate(['stock-overview/stock-at-cfs-ug']);
            }else{
              this.router.navigate(['stock-overview/all-stock-ug']);
            }
          }
        },
      },
    });
  }

  /**
   * Load pending payments
   */
  countPendingPayments(){
    this.isLoading=true;

    this.dashboardUgService.countPendingPayments()
      .subscribe((response: PendingPaymentsResponse) => {
        if(response.data){
          this.isLoading=false;
          this.pendingPayments = response.data;
        }else{
          this.isLoading=false;
        }
      });
  }

  getAvailableStockByMake():void{
    this.dashboardUgService.countAvailableStockByMake()
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.stock_available_by_make = response.data;

          this.isLoading=false;
        }else if(response.status==='no_data'){
           this.isLoading=false;
        }else{
          const errorMessage="A problem was encountered while fetching available stock by make. Please refresh the page and try again!";
          this.globalService.setGlobalWarningMessage(errorMessage);
          this.isLoading=false;
        }
      },
      error: (error) => {
        this.isLoading=false;
        this.globalService.setGlobalWarningMessage("Available Makes: "+error);
      }
    });
  }

  pageChangeEvent(event: number){
    this.page = event;
  }

  onSearchTextChange(event: Event) {
    this.searchText = (event.target as HTMLInputElement).value;
    this.page = 1; // Reset to page 1 after applying filter
  }

  onSelectChange(target: EventTarget|null) {
    if (target instanceof HTMLSelectElement) {

      if(target.value!=='' && target.value!==undefined){
        this.branchId = target.value;
      }else{
        this.branchId = null;
      }

      if(this.branchId!=='' && this.branchId!==undefined){
        this.isLoading=true;
        this.getAvailableStockByMakeForBranch(this.branchId);
      }else{
        this.isLoading=true;
        this.getAvailableStockByMake();
      }
    }
  }

  fetchBranches():void {
    this.isLoading=true;

    this.dashboardUgService.getBranches()
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.branches = response.data
          this.isLoading=false;
        }else if(response.status==='no_data'){
          const errorMessage="No branches found!";
          this.globalService.setGlobalWarningMessage(errorMessage);
          this.isLoading=false;
          this.branches = []; // Clear the branches
        }else{
          const errorMessage="Unable to load branches!";
          this.globalService.setGlobalWarningMessage(errorMessage);
          this.isLoading=false;
          this.branches = []; // Clear the branches
        }
      },
      error: (error) => {
        this.globalService.setGlobalErrorMessage("Fetching branches: "+error);
        this.isLoading=false;
        this.branches = []; // Clear the branches
      }
    });
  }

  getAvailableStockByMakeForBranch(branchId: string|null):void{
    this.dashboardUgService.countAvailableStockByMakeForBranch(branchId)
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.stock_available_by_make = response.data;
          this.isLoading=false;
        }else if(response.status==='no_data'){
           this.isLoading=false;
        }else{
          const errorMessage="A problem was encountered while fetching available stock by make. Please refresh the page and try again!";
          this.globalService.setGlobalWarningMessage(errorMessage);
          this.isLoading=false;
        }
      },
      error: (error) => {
        this.isLoading=false;
        this.globalService.setGlobalWarningMessage("Available Makes: "+error);
      }
    });
  }

  openAvailableModelsModal(make_id:string,make_name:string){
    this.make_id=make_id;
    this.make_name=make_name;

    this.getAvailableStockByModel(this.make_id,this.branchId);
  }

  closeAvailableModelsModal():void {
    if (this.availableModelsModalElement) {
      (<any>$(this.availableModelsModalElement.nativeElement)).modal('hide');
    }
  }

  openAvailableUnitsModal(model_id:string,model_name:string){
    this.model_id=model_id;
    this.model_name=model_name;

    this.getUnitsAvailableByModel(this.model_id,this.branchId);
  }

  closeAvailableUnitsModal():void {
    if (this.availableUnitsModalElement) {
      (<any>$(this.availableUnitsModalElement.nativeElement)).modal('hide');
    }
  }

  getAvailableStockByModel(make_id:string,branchId:string|null):void{
    this.isLoading=true;

    this.dashboardUgService.countAvailableStockByModel(make_id,branchId)
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.stock_available_by_model = response.data;
          this.isLoading=false;

          //Show modal
          if (this.availableModelsModalElement) {
            (<any>$(this.availableModelsModalElement.nativeElement)).modal('show');
          }
        }else if(response.status==='no_data'){
          this.isLoading=false;
          this.globalService.setGlobalWarningMessage("No models available!");
        }else{
          const errorMessage="A problem was encountered while counting available stock by model. Please refresh the page and try again!";
          this.globalService.setGlobalWarningMessage(errorMessage);
          this.isLoading=false;
        }
      },
      error: (error) => {
        this.isLoading=false;
        this.globalService.setGlobalWarningMessage("Available Models: "+error);
      }
    });
  }

  modelPageChangeEvent(event: number){
    this.model_page = event;
  }

  modelOnSearchTextChange(event: Event) {
    this.modelSearchText = (event.target as HTMLInputElement).value;
    this.model_page = 1; // Reset to page 1 after applying filter
  }

  getUnitsAvailableByModel(model_id:string,branchId:string|null):void{
    this.isLoading=true;

    this.dashboardUgService.getUnitsByModel(model_id,branchId)
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.units_by_model = response.data;
          this.isLoading=false;

          //Show modal
          if (this.availableUnitsModalElement) {
            (<any>$(this.availableUnitsModalElement.nativeElement)).modal('show');
          }
        }else if(response.status==='no_data'){
          this.isLoading=false;
          this.globalService.setGlobalWarningMessage("No units available under the selected model!");
        }else{
          const errorMessage="A problem was encountered while fetching available stock by model. Please refresh the page and try again!";
          this.globalService.setGlobalWarningMessage(errorMessage);
          this.isLoading=false;
        }
      },
      error: (error) => {
        this.isLoading=false;
        this.globalService.setGlobalWarningMessage("Available Units: "+error);
      }
    });
  }

  unitsPageChangeEvent(event: number){
    this.units_page = event;
  }

  unitsOnSearchTextChange(event: Event) {
    this.unitsSearchText = (event.target as HTMLInputElement).value;
    this.units_page = 1; // Reset to page 1 after applying filter
  }

  loadDueDutyPayments() {
    this.isLoading=true;

    this.dashboardUgService.getDueDutyPayments().subscribe({
      next: (response: any) => {
        this.isLoading=false;
        this.dueDutyPayments = response;
      },
      error: (error) => {
        this.isLoading=false;
        console.log(error);
      }
    });
  }

  //Helper methods
  getProgressBarClass(percentage: number): string {

    if (percentage < 40) {
      return 'bg-danger';
    }

    if (percentage >= 40 && percentage <= 50) {
      return 'bg-warning';
    }

    if (percentage >= 51 && percentage <= 70) {
      return 'bg-secondary';
    }

    if (percentage >= 71 && percentage <= 90) {
      return 'bg-info';
    }

    return 'bg-success';

  }
}
